<article>
    <div class="path">
        <div class="text">채용알림 > </div>
        <div>작성하기</div>
    </div>

    <form class="content" (ngSubmit)="submit()">
        <div class="btn-container">
            <button type="button" class="btn back" (click)="rollBack()" ><img src="/assets/images/btn-previous.png" alt="버튼"></button>
            <div>
                <button type="button" class="btn preview" (click)="activePreview()">미리보기</button>
                <button type="submit" class="btn submit">작성하기</button>
            </div>
        </div>

        <div class="box">
            제목<br>
            <input name="title" class="title" cols="75" rows="1" wrap="physical" [value]="notice.title" (change)="handleChange($event)">
            
        </div>
        <div class="box">
            잡코리아 url<br>
            <input name="link" class="title" cols="75" rows="1" wrap="physical" [value]="notice.link" (change)="handleChange($event)">
            
        </div>
        <div class="box">
            모집기간<br>
            <div class="input-box">
                <input type="date" class="start-date" name="startDate" [value]="notice.startDate" (change)="handleChange($event)" >
                ~
                <input type="date" class="end-date" name="endDate" [value]="notice.endDate" (change)="handleChange($event)"  >
                <input type="checkbox" class="immediate-opening" name="immediateOpening" [checked]="notice.immediateOpening" (change)="handleChecked($event)" >
                상시모집
            </div>
            
        </div>
        <div class="box">
            업무내용<br>
            <textarea name="jobDescription" class="job-description"  (change)="handleChange($event)" cols="100" rows="10" wrap="physical">{{notice.jobDescription}}</textarea>
        </div>
        <div class="box">
            지원자격<br>
            <textarea name="essentialSkill" class="essential-skill" cols="100" (change)="handleChange($event)"  rows="10" wrap="physical">{{notice.essentialSkill}}</textarea>
        </div>
        <div class="box">
            우대사항<br>
            <textarea name="extraSkill" class="extra-skill" cols="100"  (change)="handleChange($event)"  rows="10" wrap="physical">{{notice.extraSkill}}</textarea>
        </div>
    </form>

    <app-admin-recruit-preview *ngIf = "previewFlag" [notice]="notice" (previewToggle) ="unactivePreview($event)"></app-admin-recruit-preview>


</article>
